"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCache = void 0;
var tslib_1 = require("tslib");
var queryString = tslib_1.__importStar(require("query-string"));
var DefaultCache = (function () {
    function DefaultCache() {
        this._cache = {};
    }
    DefaultCache.prototype.read = function (url, options) {
        var cacheKey = this.getKey(url, options.params);
        return this._cache[cacheKey] || null;
    };
    DefaultCache.prototype.write = function (url, options, response) {
        var cacheKey = this.getKey(url, options.params);
        this._cache[cacheKey] = response;
    };
    DefaultCache.prototype.getKey = function (url, params) {
        if (params === void 0) { params = {}; }
        if (Object.keys(params).length === 0) {
            return url;
        }
        return "".concat(url, "?").concat(queryString.stringify(params));
    };
    return DefaultCache;
}());
exports.DefaultCache = DefaultCache;
